<template>
  <div
    v-touch="{
      left: onSwipe,
      right: onSwipe,
    }"
    class="user-layout-container justify-center d-flex h-100"
  >
    <div class="w-100 position-relative">
      <UserLayoutTopMenu
        class="mb-4"
        :title="sidebarTitle"
        :icon="sidebarIcon"
        :items="sidebarItems"
      />
      <div
        class="container--fluid user-layout-body d-flex flex-column ml-0 pt-6"
        :class="{ xs: $vuetify.breakpoint.xs }"
      >
        <transition name="fade" mode="out-in">
          <slot />
        </transition>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'SUserLayout',
};
</script>

<script setup lang="ts">
import UserLayoutTopMenu from './UserLayoutTopMenu.vue';
import { useRouteRef, useRouter } from '../../../composables';

const props = defineProps({
  sidebarTitle: {
    type: String,
    required: true,
  },
  sidebarIcon: {
    type: String,
    required: true,
  },
  sidebarItems: {
    type: Array,
    default: () => [],
  },
});

const route = useRouteRef();
const router = useRouter();

function onSwipe({ touchstartX, touchendX }: { touchstartX: number; touchendX: number }) {
  const minSwipeDistance = 100;
  const isEnoughDistance =
    Math.abs(touchstartX - touchendX) > minSwipeDistance;
  if (isEnoughDistance) {
    const direction = touchstartX - touchendX > 0 ? 'left' : 'right';
    const currentRouteName = route.value.name;
    const { prevRoute, nextRoute } = (props.sidebarItems as Array<{ route: string }>).reduce(
      (acc: { prevRoute: string | null; nextRoute: string | null }, item, index, arr) => {
        if (currentRouteName === item.route) {
          if (arr[index + 1]) acc.nextRoute = arr[index + 1].route;
          if (arr[index - 1]) acc.prevRoute = arr[index - 1].route;
        }
        return acc;
      },
      {
        prevRoute: null,
        nextRoute: null,
      }
    );
    if (direction === 'right' && prevRoute) {
      router.push(prevRoute);
    } else if (direction === 'left' && nextRoute) {
      router.push(nextRoute);
    }
  }
}
</script>

<style scoped lang="scss">
.user-layout-sidebar {
  height: calc(100% + 60px) !important;
}

.user-layout-body {
  padding: 200px 0;

  &.xs {
    padding-left: 0;
  }
}
</style>
